export default "__VITE_ASSET__NxaAw20v__"